import React, {useMemo} from 'react';
import {ReactComponent as OrdersIcon} from '../../assets/icons/orders.svg';
import {ReactComponent as WalletIcon} from '../../assets/icons/wallet.svg';
import {ReactComponent as ShoppingIcon} from '../../assets/icons/shopping-bag.svg';
import {ReactComponent as StarIcon} from '../../assets/icons/starFill.svg';

const formatPrice = (value) =>
    Number(value || 0).toLocaleString('fa-IR');

const formatCount = (value) =>
    Number(value || 0).toLocaleString('fa-IR');

const ComponentsReports = ({data}) => {
    const foods = data?.foods ?? [];
    const orderCount = Number(data?.count || 0);
    const totalSales = Number(data?.price || 0);
    const averageOrder = orderCount > 0 ? Math.round(totalSales / orderCount) : 0;

    const rankedFoods = useMemo(() => {
        const maxRevenue = Math.max(...foods.map((item) => Number(item.total_price || 0)), 1);

        return [...foods]
            .sort((a, b) => Number(b.total_price || 0) - Number(a.total_price || 0))
            .map((item, index) => ({
                ...item,
                rank: index + 1,
                share: Math.round((Number(item.total_price || 0) / maxRevenue) * 100),
            }));
    }, [foods]);

    const topFood = rankedFoods[0];

    const stats = [
        {
            key: 'orders',
            label: 'تعداد سفارش',
            value: formatCount(orderCount),
            suffix: 'سفارش',
            icon: OrdersIcon,
            tone: 'blue',
        },
        {
            key: 'sales',
            label: 'مجموع فروش',
            value: formatPrice(totalSales),
            suffix: 'تومان',
            icon: WalletIcon,
            tone: 'orange',
        },
        {
            key: 'average',
            label: 'میانگین هر سفارش',
            value: formatPrice(averageOrder),
            suffix: 'تومان',
            icon: ShoppingIcon,
            tone: 'green',
        },
        {
            key: 'top',
            label: 'پرفروش‌ترین غذا',
            value: topFood?.food_name || '—',
            suffix: topFood ? `${formatCount(topFood.total_orders)} عدد` : '',
            icon: StarIcon,
            tone: 'purple',
            compact: true,
        },
    ];

    return (
        <div className="rest-reports-dashboard">
            <div className="rest-reports-stats">
                {stats.map((stat) => {
                    const Icon = stat.icon;

                    return (
                        <article
                            key={stat.key}
                            className={`rest-reports-stat rest-reports-stat--${stat.tone}`}
                        >
                            <div className="rest-reports-stat__icon" aria-hidden="true">
                                <Icon/>
                            </div>
                            <div className="rest-reports-stat__content">
                                <span className="rest-reports-stat__label">{stat.label}</span>
                                <strong
                                    className={`rest-reports-stat__value${stat.compact ? ' rest-reports-stat__value--compact' : ''}`}
                                    title={stat.value}
                                >
                                    {stat.value}
                                </strong>
                                {stat.suffix ? (
                                    <span className="rest-reports-stat__suffix">{stat.suffix}</span>
                                ) : null}
                            </div>
                        </article>
                    );
                })}
            </div>

            <section className="rest-reports-panel">
                <div className="rest-reports-panel__header">
                    <div>
                        <h2 className="rest-reports-panel__title">رتبه‌بندی غذاها</h2>
                        <p className="rest-reports-panel__subtitle">
                            بر اساس تعداد فروش و مبلغ در بازه انتخاب‌شده
                        </p>
                    </div>
                    <span className="rest-reports-panel__badge">
                        {formatCount(rankedFoods.length)} غذا
                    </span>
                </div>

                <div className="rest-reports-food-list">
                    {rankedFoods.map((item) => (
                        <article className="rest-reports-food" key={item.food_id}>
                            <div className="rest-reports-food__rank">
                                {formatCount(item.rank)}
                            </div>

                            <div className="rest-reports-food__body">
                                <div className="rest-reports-food__row">
                                    <h3 className="rest-reports-food__name">{item.food_name}</h3>
                                    <div className="rest-reports-food__metrics">
                                        <span className="rest-reports-food__qty">
                                            {formatCount(item.total_orders)} عدد
                                        </span>
                                        <strong className="rest-reports-food__price">
                                            {formatPrice(item.total_price)}
                                            <small>تومان</small>
                                        </strong>
                                    </div>
                                </div>

                                <div
                                    className="rest-reports-food__bar"
                                    role="presentation"
                                    aria-hidden="true"
                                >
                                    <span
                                        className="rest-reports-food__bar-fill"
                                        style={{width: `${item.share}%`}}
                                    />
                                </div>
                            </div>
                        </article>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default ComponentsReports;
